import { useObservable } from "thrive-observable-react";

// services
import { CAS } from "../service/ChatConfig.Service";
import { CS } from '../service/Chat.Service'

//interfaces
import { ChatState, IChatMeta } from "../interfaces";

// components
import PeopleSearch from '../containers/PeopleSearch';
import ChatConversation from '../containers/ChatConversations';



const ViewContainerMapper = ({chatState}: {chatState:ChatState}) => {

    const chats = useObservable<IChatMeta[]>(CS.chats)

    switch(chatState) {
        case ChatState.PEOPLESEARCH:
            return <PeopleSearch />
        case ChatState.CHAT:
            return <ChatConversation />
        default:
            return <span className="chat-placeholder-text">{chats.length > 0 && CAS.localisationStrings.SelectAConversationOrStartANewChat()}</span>
    }
}

export default ViewContainerMapper;